var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0412 0.958682C14.9155 0.833014 14.7585 0.743141 14.5865 0.69832C14.4145 0.653498 14.2336 0.655349 14.0625 0.703682H14.0531L2.05687 4.34368C1.86159 4.39984 1.68806 4.51415 1.55937 4.6714C1.43068 4.82865 1.35295 5.02137 1.33653 5.2239C1.3201 5.42642 1.36576 5.62915 1.46743 5.80508C1.5691 5.98101 1.72194 6.12179 1.90562 6.20868L7.25687 8.74306L9.79125 14.0943C9.87126 14.2657 9.99863 14.4106 10.1583 14.5119C10.318 14.6132 10.5034 14.6668 10.6925 14.6662C10.7212 14.6662 10.75 14.6649 10.7787 14.6624C10.9806 14.6461 11.1725 14.5684 11.3289 14.4398C11.4854 14.3112 11.5987 14.1379 11.6537 13.9431L15.2912 1.94681C15.2912 1.94368 15.2912 1.94056 15.2912 1.93743C15.3402 1.76678 15.3429 1.58618 15.2989 1.41417C15.255 1.24216 15.166 1.08495 15.0412 0.958682ZM10.6981 13.6568L10.695 13.6656L8.23499 8.47243L11.1875 5.51931C11.2773 5.42478 11.3266 5.2989 11.325 5.16852C11.3233 5.03814 11.2708 4.91357 11.1786 4.82137C11.0864 4.72917 10.9618 4.67663 10.8314 4.67496C10.701 4.67329 10.5752 4.72262 10.4806 4.81243L7.52749 7.76493L2.33374 5.30493H2.34249L14.3337 1.66618L10.6981 13.6568Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroSentIcon);
export default __webpack_public_path__ + "static/media/intro-sent-icon.86a1535fa3293fcccd467626c717c167.svg";
export { ForwardRef as ReactComponent };